import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("profile/basic-update", body);
  return data;
};
